module.exports = "/images/outline-expand_more-24px.svg?af961b136dcf93ffaf7fee8249aeaa5c";